import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { ErrorAnimationView } from './ErrorAnimationView';

export const ErrorAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    return <ErrorAnimationView uid={widget.uid} margin={widget.options?.margin} />;
};
